module.exports = "/_next/static/images/OgImage-3cdd21a0698773bca839d36dc81ba609.png";